import { render, staticRenderFns } from "./ssingle-blog.vue?vue&type=template&id=39459fb0&"
import script from "./ssingle-blog.vue?vue&type=script&lang=js&"
export * from "./ssingle-blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports